module.exports = __webpack_public_path__ + "img/6.8d8e4e42.png";